<template>
  <div>
    <div class="text-center mt-6" v-if="!dataLoaded">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </div>

    <div v-else>
      <v-row class="my-0">
        <v-col cols="12" class="py-0">
          <v-card class="base-card main-content pa-5">
            <div class="inputs">
              <v-autocomplete
                :loading="employeesLoading"
                v-model="department"
                label="Кафедра"
                placeholder="Выберите значение из списка"
                :items="departments"
                item-text="name"
                hide-no-data
                hide-details
                hide-selected
                return-object
                clearable
                @change="getEmployeesData"
              />

              <v-autocomplete
                v-if="department && !employeesLoading"
                :value="headTeacher"
                class="mt-6"
                label="Заведующий учебной частью"
                placeholder="Выберите значение из списка"
                :items="employees"
                item-text="employeeInfo"
                hide-no-data
                hide-details
                hide-selected
                return-object
                @change="confirmSetHeadTeacher"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <SaveConfirmDialog
      :dialog="confirmDialog"
      :loading="loading"
      @confirm="setHeadTeacher"
      @closeConfirmModal="cancelConfirmDialog"
    />
  </div>
</template>

<script>
import { departmentApi, headTeacherApi } from '@/api'
import { mapGetters } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'
import { Employee } from '@/models'
import PageTitle from '@/components/ui/Title'
import SaveConfirmDialog from '@/components/department/headTeacher/dialogs/SaveConfirm'

export default {
  name: 'HeadTeacher',

  metaInfo: {
    title: 'Заведующий учебной частью'
  },

  components: {
    PageTitle,
    SaveConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getDepartmentsList()
    this.dataLoaded = true
  },

  mounted() {
    this.hideHtmlOverflow()
  },

  destroyed() {
    this.showHtmlOverflow()
  },

  data: () => ({
    dataLoaded: false,
    loading: false,
    employeesLoading: false,
    saveLoading: false,
    confirmDialog: false,
    selectedItem: null,
    departments: [],
    employees: [],

    oldHeadTeacher: null,
    headTeacher: null,
    department: null
  }),

  methods: {
    async getDepartmentsList() {
      try {
        this.departments = await departmentApi.getDepartmentsList()
      } catch (e) {
        console.log(e.status)
      }
    },

    async getEmployeesData() {
      try {
        this.employeesLoading = true

        await this.getEmployeesList()
        await this.getHeadTeacher()
      } catch (e) {
        console.log(e.status)
      } finally {
        this.employeesLoading = false
      }
    },

    async getEmployeesList() {
      try {
        const data = await departmentApi.getEmployeesListByDepartmentId(this.department.id)
        this.employees = data.map(el => Employee.buildFromAPI(el))
      } catch (e) {
        console.log(e.status)
      }
    },

    async getHeadTeacher() {
      try {
        const data = await headTeacherApi.getHeadTeacher(this.department.id)
        this.headTeacher = Employee.buildFromAPI(data)
      } catch (e) {
        console.log(e.status)
      }
    },

    async setHeadTeacher() {
      try {
        this.loading = true

        const body = {
          ...this.selectedItem.getForAPI(),
          departmentId: this.department.id
        }

        await headTeacherApi.setHeadTeacher(body)
        await departmentApi.setDepartmentHeadTeacher(this.department.id, body)
        this.headTeacher = _cloneDeep(this.selectedItem)
        this.$toastr('success', '', 'Заведующий учебной частью сохранен')
        this.closeConfirmDialog()
      } catch (e) {
        this.headTeacher = this.oldHeadTeacher
        this.showErrorMessage(e, 'Ошибка сохранения заведующего учебной частью')
      } finally {
        this.loading = false
      }
    },

    confirmSetHeadTeacher(item) {
      this.oldHeadTeacher = _cloneDeep(this.headTeacher)
      this.selectedItem = item
      this.confirmDialog = true
    },

    cancelConfirmDialog() {
      this.selectedItem = null
      this.headTeacher = this.oldHeadTeacher
      this.confirmDialog = false
    },

    closeConfirmDialog() {
      this.selectedItem = null
      this.confirmDialog = false
    },

    hideHtmlOverflow() {
      document.querySelector('html').style.setProperty('overflow-y', 'hidden', 'important')
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    }
  }
}
</script>

<style scoped>
.main-content .inputs {
  max-width: 600px;
}
</style>